// extracted by mini-css-extract-plugin
module.exports = {"container":"Panel__container___z3d7F","shade":"Panel__shade___6wTft","panel":"Panel__panel___-yBwe","close":"Panel__close___FdcrC","isOpen":"Panel__isOpen___133QL"};